import { PATIENT_WAITING_LIST } from "@/api_framework/api_config";
import { IPatientWaitingListActionBody, IPatientWaitingListActionResponse } from "@/api_framework/api_modals/Patients";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
// returns new created userId
export const usePatientWaitingActionAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const [updatedBookingId, setUpdatedBookingId] = useState<string | null>(null);
  const execute = useCallback(
    async (bookingId: string, formData: IPatientWaitingListActionBody): Promise<string | null> => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key) as string;
        const requestHeaders = new Headers();
        requestHeaders.append("Authorization", `${accessToken}`);
        await axios
          .put(`${PATIENT_WAITING_LIST?.WAITING_LIST_ACTION?.baseURL}${bookingId}/`, formData, {
            headers: { Authorization: requestHeaders.get("Authorization") },
          })
          .then((res: AxiosResponse<IPatientWaitingListActionResponse>) => {
            if (res.data.status === true) {
              setUpdatedBookingId(res.data.data.booking_id);
              toast.success("Booking updated successfully");
            } else {
              setUpdatedBookingId(null);
              toast.error("Booking data updated failed");
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e)
            return null;
          });
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
        return null;
      }
      return null;
    },
    [],
  );
  return { updatedBookingId, execute };
};
